import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type { GetAssetFilesResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  suiteId: string
  children?: (data: GetAssetFilesResponse) => ReactElement
}

const GetSuiteFilesRequest = ({
  suiteId,
  children
}: Props) => {
  const url = `${VAM_SERVICE}/assets/${suiteId}/latest_version/index`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetSuiteFilesRequest
